import React from "react";
// routing
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
//component
import Nav from "./components/nav/Nav";
import Home from "./components/HomePage";
import AboutMe from "./components/AboutMePage";
import Projects from "./components/ProjectsPage";
import Contact from "./components/ContactPage";
import Blogs from "./components/BlogPage";
import CaseStudy from "./components/caseStudy/CaseStudy";
import Article from "./components/article/Article";
import Footer from "./components/footer/Footer";

// styles
import { GlobalStyle } from "./GlobalStyle";
import Redirect from "./components/redirect/redirect";

// navigation
const Navigations = () => {
  const location = useLocation();

  return (
      <AnimatePresence>
          <Routes location={location} key={location.pathname}>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<AboutMe />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/project/:title" element={<CaseStudy />} />
              <Route path="/blog" element={<Blogs />} />
              <Route path="/article/:title" element={<Article />} />
              <Route path="/contact" element={<Contact />} />
          </Routes>
      </AnimatePresence>
  );
};



const App = () => {
  return (
    <BrowserRouter>
        <Redirect />
        <Nav />
        <Navigations />
        <Footer />
      <GlobalStyle />  
    </BrowserRouter>
  );
};

export default App;
